import { trackEvent } from './analytics';

export const DAY_MS = 24 * 60 * 60 * 1000;

export const isHiddenUntil = (key: string): boolean => {
  try {
    return Date.now() < Number(localStorage.getItem(key));
  } catch {
    return false;
  }
};

export const hideUntil = (key: string, durationMs: number): void => {
  try {
    localStorage.setItem(key, String(Date.now() + durationMs));
  } catch {
    // Blocked storage: the caller's in-memory state hides it for this session only
  }
};

export const track = (eventName: string, props: Record<string, string>): void => {
  try {
    trackEvent(eventName, { props });
  } catch {
    // An adblocker must never break the app adoption prompts
  }
};
